import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"


export default function AppFuelPolicyAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Fuel Policy"
		placeholder="Select fuel policy"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/fuel_policy`}
		{...props}
	/>
}